import styled from 'styled-components'
import { VerticalStyledScrollBar, theme } from '~/styles'

export const HeaderContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 32px;
  border-radius: 4px;
  background-color: ${props => props.theme.colors.colorf1f4f6};
  color: ${props => props.theme.colors.color5a6a7e};
  padding: 12px 16px 12px 16px;
  margin-bottom: 5px;
  font-size: 12px;
`

export const HeaderFirst = styled.div`
  display: flex;
  flex: 2;
`

export const HeaderItem = styled.div`
  display: flex;
  flex: 1;
`

export const HeaderSelect = HeaderItem

export const TableContainer = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: auto;
  max-height: 160px;
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  margin-bottom: 5px;
  overflow: auto;

  ${VerticalStyledScrollBar}
`

export const TableContent = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  padding: 12px 16px 12px 16px;
  margin-bottom: 5px;
  font-size: 14px;

  &:hover {
    background-color: ${props => props.theme.colors.colorf4f6f8};
  }
  transition: 0.4s;
`

export const TableFirstContent = styled.div`
  display: flex;
  flex: 2;
  align-items: center;
`

export const TableAvatar = styled.div``

export const TableName = styled.div`
  width: 65%;
  color: ${props => props.theme.colors.color2d3139};
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 20px;
`

export const TableItem = styled.div`
  display: flex;
  flex: 1;
`

export const TableSelect = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  height: 30px;

  button {
    font-size: 13px;
    height: auto;
  }
`
